<template>
 
             
          <div v-if="business" class="w3-card-4">
                <header class="w3-container w3-theme-d2">
                    <h3>About {{business.name}}</h3>
                </header>
                
                <p class="w3-small" style="padding:10px">{{business.pwa.about}}</p>

                <p class="w3-small" style="padding:10px">{{business.pwa.howto}}</p>

                <p class="w3-small" style="padding:10px">{{business.pwa.instructions}}</p>

          </div>       
    

    
    
</template>


<script> 
  export default {    
   props:["business"]
  };
</script>



// WEBPACK FOOTER //
// src/components/home/HomeAboutTile.vue